<section id="section-report" class="container-fluid mt-1">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{salesRemissionPrintModel.inventoryOutputId}}" class="head col-12 col-lg-12">
                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{salesRemissionPrintModel.inventoryOutputId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{salesRemissionPrintModel.branchName}}</p>

                  <!--Nombre Remisión de Venta -->
                  <p id="nombre-remision-venta-{{salesRemissionPrintModel.inventoryOutputId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'REMISIÓN DE VENTA Nro.'+ salesRemissionPrintModel.consecutive}}</p>

                  <!--Dirección  -->
                  <label id="t-direccion-{{salesRemissionPrintModel.inventoryOutputId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-direccion' | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-{{salesRemissionPrintModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{salesRemissionPrintModel.address}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-{{salesRemissionPrintModel.inventoryOutputId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-telefono' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-{{salesRemissionPrintModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{salesRemissionPrintModel.phone}}</p>

                  <!-- Fecha salida -->
                  <label id="t-fecha-remision-venta-{{salesRemissionPrintModel.inventoryOutputId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-fecha-remision-venta' | formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-remision-venta-{{salesRemissionPrintModel.inventoryOutputId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{salesRemissionPrintModel.dateSalesRemission | date: 'dd/MM/yyyy'}}</p>

                  <!-- Nit Cliente  -->
                  <label id="t-nit-cliente-{{salesRemissionPrintModel.inventoryOutputId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-nit-cliente' | formatLabelPipe : elementsLabel}}</label>
                  <p id="nit-cliente-{{salesRemissionPrintModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{salesRemissionPrintModel.clientNit }}
                  </p>

                  <!-- Cliente  -->
                  <label id="t-cliente-{{salesRemissionPrintModel.inventoryOutputId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-cliente' | formatLabelPipe : elementsLabel}}</label>
                  <p id="cliente-{{salesRemissionPrintModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{salesRemissionPrintModel.clientName }}</p>

                  <!-- Inventario  -->
                  <label id="t-inventario-{{salesRemissionPrintModel.inventoryOutputId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-inventario' | formatLabelPipe : elementsLabel}}</label>
                  <p id="inventario-{{salesRemissionPrintModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{salesRemissionPrintModel.inventoryName}}
                  </p>
                  <!--C.Costos  -->
                  <!-- <label id="t-centro-costos-{{ remissionModel.remissionId }}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{ "t-centro-costos" | formatLabelPipe : elementsLabel }}</label>
                  <p id="centro-costos-{{ remissionModel.remissionId }}" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{ remissionModel.costCenterCodeName }}
                  </p> -->
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print id="detalle-remision-{{ salesRemissionPrintModel.inventoryOutputId }}"
                  [columns]="columns" [data]="salesRemissionPrintModel.salesRemissionDetails" [idMap]="idMap"
                  [documentId]="salesRemissionPrintModel.inventoryOutputId" [footerVisible]="true"
                  [editFormat]="editFormat" (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <!-- Observaciones -->
          <div id="foot-{{salesRemissionPrintModel.inventoryOutputId}}" class="foot mt-1 container-observations">
            <label id="t-observacion-remision-venta-{{salesRemissionPrintModel.inventoryOutputId}}"
              (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
              *ngIf="salesRemissionPrintModel.observation">
              {{'t-observacion-remision-venta' | formatLabelPipe : elementsLabel}}</label>
            <p id="observacion-remision-venta-{{salesRemissionPrintModel.inventoryOutputId}}"
              (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
              *ngIf="salesRemissionPrintModel.observation">
              {{salesRemissionPrintModel.observation}}</p>

            <!-- Firma Recibido-->
            <p id="linea-firma-recibido-{{salesRemissionPrintModel.inventoryOutputId}}" class="write-line"
              (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
            <label id="t-linea-recibido-{{salesRemissionPrintModel.inventoryOutputId}}"
              (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
              {{'t-linea-recibido' | formatLabelPipe : elementsLabel}}</label>
          </div>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
                <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
                <p id="usuario-impresion" class="pe-4"> {{salesRemissionPrintModel.userAuthenticated}}</p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                    SAS. Nit.811.022.121-1. www.altos-soft.com</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>